import React, { useCallback } from 'react';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './style.scss';

import IconFemtasy from 'components/IconFemtasy';
import Message from 'components/Message';
import Typography from 'components/Typography';

interface MatchVoices {
  [key: string]: {
    [key: string]: string[];
  };
}

const voices: MatchVoices = {
  de: {
    female: ['Nela', 'Pantea', 'Lorena'],
    male: ['Emanuel', 'Samuel', 'Raphael'],
    either: ['Nela', 'Gami', 'Raphael'],
  },
  'fr-fr': {
    female: ['Daphné', 'Diane', 'Léa'],
    male: ['Maël', 'Adam', 'Sacha'],
    either: ['Maël', 'Alix', 'Léa'],
  },
  'en-gb': {
    female: ['Grace', 'Ruby', 'Esme'],
    male: ['Charlie', 'James', 'Jackson'],
    either: ['Charlie', 'Gami', 'Esme'],
  },
  'en-us': {
    female: ['Grace', 'Ruby', 'Esme'],
    male: ['Charlie', 'James', 'Jackson'],
    either: ['Charlie', 'Gami', 'Esme'],
  },
};

const SpeakerMatch = ({ speaker }: { speaker: string }) => {
  const { locale } = useIntl();
  const localeVoices = voices[locale.toLocaleLowerCase()];

  const femaleVoices = localeVoices['female'];
  const maleVoices = localeVoices['male'];
  const eitherVoices = localeVoices['either'];

  const handleSpeakerColor = useCallback(() => {
    if (maleVoices.includes(speaker)) {
      return 'speaker--MALE';
    } else if (femaleVoices.includes(speaker)) {
      return 'speaker--FEMALE';
    } else if (eitherVoices.includes(speaker)) {
      return 'speaker--DIVERSE';
    }
  }, [speaker, femaleVoices, maleVoices, eitherVoices]);

  return (
    <div className="SpeakerMatch">
      <div className="you">
        <Typography variant="h2">
          <Message message={{ id: 'components.LoversQuiz.ResultsPage.user' }} />
        </Typography>
      </div>
      <span className="heart">
        <IconFemtasy icon="Heartsolid" size="24" color="primary" />
        <IconFemtasy
          className="heart__white"
          icon="Heartline"
          size="24"
          color="white"
        />
      </span>
      <div className={classNames('speaker', handleSpeakerColor())}>
        <Typography variant="h2">{speaker}</Typography>
      </div>
    </div>
  );
};

export default SpeakerMatch;
